"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("@material-ui/core/styles");
var core_1 = require("@material-ui/core");
var lab_1 = require("@material-ui/lab");
var RichTextEditor_1 = __importDefault(require("../../RichTextEditor"));
var Button_1 = __importDefault(require("../../../Button"));
exports.useStyles = styles_1.makeStyles(function (theme) {
    return styles_1.createStyles({
        root: {
            position: 'relative',
            backgroundColor: '#F0F4F8',
            borderRadius: theme.shape.borderRadius,
            padding: theme.spacing(1),
            marginBottom: theme.spacing(2),
        },
        image: {
            maxWidth: '100%',
        },
        progressContainer: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'absolute',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            color: '#FFF',
        },
        progressRing: {
            color: '#FFF',
            marginBottom: theme.spacing(2),
        },
    });
});
var EditorExtractTextDialog = function (_a) {
    var error = _a.error, onClickCancel = _a.onClickCancel, onClickInsertText = _a.onClickInsertText, onClickInsertImage = _a.onClickInsertImage, RichTextEditorProps = _a.RichTextEditorProps, editorValue = _a.editorValue, src = _a.src, status = _a.status, uploadProgress = _a.uploadProgress, other = __rest(_a, ["error", "onClickCancel", "onClickInsertText", "onClickInsertImage", "RichTextEditorProps", "editorValue", "src", "status", "uploadProgress"]);
    var classes = exports.useStyles();
    return (react_1.default.createElement(core_1.Dialog, __assign({ fullWidth: true, maxWidth: "md" }, other),
        react_1.default.createElement(core_1.DialogContent, null,
            react_1.default.createElement(core_1.Grid, { container: true, spacing: 4 },
                react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 6, style: { position: 'relative' } },
                    src && react_1.default.createElement("img", { className: classes.image, alt: "", src: src }),
                    (status === 'uploading' || status === 'analyzing') && (react_1.default.createElement("div", { className: classes.progressContainer },
                        react_1.default.createElement(core_1.CircularProgress, { color: "inherit", className: classes.progressRing, variant: status === 'uploading' ? 'static' : 'indeterminate', value: uploadProgress, size: 30 }),
                        react_1.default.createElement(core_1.Typography, { variant: "h5" },
                            status === 'uploading' ? 'Uploading' : 'Analyzing',
                            " image")))),
                react_1.default.createElement(core_1.Grid, { item: true, xs: 12, sm: 6 },
                    status === 'no-text' && (react_1.default.createElement(lab_1.Alert, { severity: "error" }, "We couldn`'`t find any text in this image.")),
                    status === 'error' && (react_1.default.createElement(lab_1.Alert, { severity: "error" }, error === 'INTERNAL'
                        ? 'Oops! An error occured when trying to analyze your image. Please try again later.'
                        : error)),
                    !editorValue && react_1.default.createElement(RichTextEditor_1.default, __assign({}, RichTextEditorProps)),
                    editorValue && (react_1.default.createElement(RichTextEditor_1.default, __assign({}, RichTextEditorProps, { initialValue: editorValue })))))),
        react_1.default.createElement(core_1.DialogActions, null,
            react_1.default.createElement(Button_1.default, { variant: "text", onClick: onClickCancel }, "Cancel"),
            react_1.default.createElement(Button_1.default, { variant: "outlined", onClick: onClickInsertImage }, "Insert Image"),
            react_1.default.createElement(Button_1.default, { variant: "contained", onClick: onClickInsertText }, "Insert Text"))));
};
exports.default = EditorExtractTextDialog;
//# sourceMappingURL=EditorExtractTextDialog.js.map